import React from 'react'
import './PeopleBar.less'

interface IPeopleBarProps {
  percentage: number
}

const PeopleBar = ({ percentage }: IPeopleBarProps) => {
  return (
    <div className="PeopleBar">
      <div
        className="PeopleBar__filling"
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  )
}

export default PeopleBar
